var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_755",
    x: 0,
    y: 0,
    width: 56,
    height: 55,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27602",
    "data-name": "Grupo 27602",
    transform: "translate(-1319 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23456",
    "data-name": "Grupo 23456",
    transform: "translate(1328.596 276.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.6, -5.4)",
    filter: "url(#Rect\\xE1ngulo_755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_755-2",
    "data-name": "Rect\\xE1ngulo 755",
    width: 38,
    height: 37,
    rx: 18.5,
    transform: "translate(9 6)",
    fill: "#76BC21"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66304",
    "data-name": "Trazado 66304",
    d: "M233.873,210.046a1.93,1.93,0,0,1-2.729,0l-4.095-4.095-4.095,4.095a1.93,1.93,0,0,1-2.731-2.729l4.095-4.1-4.095-4.095a1.93,1.93,0,0,1,2.731-2.729l4.095,4.095,4.095-4.095a1.93,1.93,0,1,1,2.729,2.729l-4.095,4.095,4.095,4.1A1.93,1.93,0,0,1,233.873,210.046Z",
    transform: "translate(1119.951 92.278)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSuccess);
export default __webpack_public_path__ + "static/media/IconoSuccess.1138a97106dd92a43bff2c8dfcfe7327.svg";
export { ForwardRef as ReactComponent };